"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _zod = require("zod");

var widgetName = 'html_widget';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-html_widget';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.object({
  title: _zod.z.string(),
  html: _zod.z.string().optional()
});

exports.config = config;

var CustomHtml = function CustomHtml(_ref) {
  var title = _ref.title,
      html = _ref.html;
  return (0, _preact.h)("div", {
    className: "custom-html-widget-wrapper"
  }, title ? (0, _preact.h)("div", {
    className: "sitewidth"
  }, (0, _preact.h)("div", {
    className: "col"
  }, (0, _preact.h)("h3", {
    className: "widget__heading"
  }, title))) : null, (0, _preact.h)("section", {
    className: "full-width custom-html",
    dangerouslySetInnerHTML: {
      __html: html || ''
    }
  }));
};

var _default = CustomHtml;
exports.default = _default;